import React, { useContext } from 'react';
import SwitchInput from '../../../../Components/SwitchInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const LogAdditionalData = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Log Additional Data"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Log Additional Data"']}
				description="Manage custom Logging via Framerate Player"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid
				container
				rowSpacing={2.4}
				style={{ marginTop: '3rem', marginLeft: '5rem', width: '90%' }}
			>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.shouldLogVideoWatchTime'}
						label="Log Video Watch Time"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.logTabChangeCounter'}
						label="Tab Change Counter"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.logFlags'}
						label="Flags"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.logPlayerHeight'}
						label="Player Height"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.logPlayerWidth'}
						label="Player width"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.logPreload'}
						label="Preload"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<SwitchInput
						keyData={keyData + '.shouldLogAllAdRequests'}
						label="Should Log All Ad Request"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default LogAdditionalData;
